import { cn } from "../lib/cn.js";

/**
 * 单一 svg spinner（无 label）— 用于按钮内内联。
 *
 * 需要 "加载中…" 文字模式时用 `<InlineLoading label="…" />`，避免页面级 5 处重复。
 */
export function Spinner({
  size = "md",
  className,
}: {
  size?: "sm" | "md" | "lg";
  className?: string;
}): JSX.Element {
  const dim = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-8 w-8" : "h-6 w-6";
  return (
    <svg
      className={cn("animate-spin text-dosia-accent", dim, className)}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        className="opacity-25"
      />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * 页面内联加载态：Spinner + 文字。
 * dashboard / list / detail 等 5 处统一用。
 */
export function InlineLoading({
  label = "加载中…",
  className,
}: {
  label?: string;
  className?: string;
}): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2 text-dosia-text-secondary", className)}>
      <Spinner size="sm" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
